(function (window, document) {
  'use strict';

  var FUNNEL_PATH = '/pages/novahair-sales-staging';
  var FUNNEL_ID = 'novahair-sales-staging';
  var PAGE_ID = 'novahair-sales-staging';
  var SCHEMA_VERSION = 1;
  var GA4_MEASUREMENT_ID = 'G-E01KRGEKQR';
  var MAIN_PRODUCT_ID = '10341269274919';
  var BRIDGE_COOKIE = '_nh_ph_context';
  var EXCLUSION_COOKIE = '_tbg_analytics_exclude';
  var BRIDGE_MAX_AGE_SECONDS = 30 * 24 * 60 * 60;
  var EXCLUSION_MAX_AGE_SECONDS = 7200;
  var PENDING_ACTION_MAX_AGE_MS = 2 * 60 * 1000;
  var ATTRIBUTION_STORAGE_KEY = 'tbg_novahair_attribution_v1';
  var SHADE_IDS = ['black', 'darkbrown', 'mediumbrown', 'lightbrown', 'purple', 'red'];
  var BUMP_VARIANTS = {
    50459892580647: 'hair_gloss_spray',
    51885840072999: 'scalp_massage_brush',
    52010595320103: 'argan_hair_mask',
    51885840400679: 'beauty_headband'
  };
  var SECTION_MAP = [
    { selector: '#buy', id: 'buy_box', name: 'Buy box' },
    { selector: '.proof-bar', id: 'proof_bar', name: 'Trust proof bar' },
    { selector: '#before-after', id: 'before_after', name: 'Before and after' },
    { selector: '#mechanism', id: 'mechanism', name: 'How it works' },
    { selector: '#formula', id: 'formula', name: 'Formula' },
    { selector: '#how-to-use', id: 'how_to_use', name: 'How to use' },
    { selector: '#social-proof', id: 'social_proof', name: 'Social proof' },
    { selector: '#comparison', id: 'comparison', name: 'Comparison' },
    { selector: '#offer-reentry', id: 'offer_reentry', name: 'Offer re-entry' },
    { selector: '#beard-use', id: 'beard_use', name: 'Beard use' },
    { selector: '#guarantee', id: 'guarantee', name: 'Guarantee' },
    { selector: '#faq', id: 'faq', name: 'FAQ' },
    { selector: '#transition-banner', id: 'transition_banner', name: 'Transition banner' },
    { selector: '#reviews-full', id: 'reviews_full', name: 'Reviews gallery' },
    { selector: 'footer.footer', id: 'footer', name: 'Footer' }
  ];

  var normalizedPath = String(window.location.pathname || '').replace(/\/$/, '');
  if (normalizedPath !== FUNNEL_PATH || window.__NH_POSTHOG_FUNNEL_V1__) return;
  window.__NH_POSTHOG_FUNNEL_V1__ = true;

  var sectionSeen = Object.create(null);
  var sectionTimers = new Map();
  var sectionStates = new Map();
  var sectionEntries = [];
  var deepestSection = null;
  var sectionScrollFrame = 0;
  var drawerWasOpen = false;
  var drawerOpenSequence = 0;
  var pendingAction = null;
  var lastBridgeFingerprint = '';
  var lastCartSummary = {};
  var sentActionIds = Object.create(null);
  var recentActions = [];
  var initialViewItemSent = false;
  var initialMetaViewContentSent = false;
  var initialViewEventId = '';

  function safeText(value, limit) {
    if (value === null || value === undefined) return '';
    return String(value).replace(/\s+/g, ' ').trim().slice(0, limit || 160);
  }

  function safeNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : undefined;
  }

  function randomId(prefix) {
    var value = '';
    try {
      value = window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : '';
    } catch (_) {}
    if (!value) value = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
    return safeText(prefix || 'action', 24) + '-' + value;
  }

  function readCookie(name) {
    try {
      var prefix = name + '=';
      var parts = String(document.cookie || '').split(';');
      for (var index = 0; index < parts.length; index += 1) {
        var part = parts[index].trim();
        if (part.indexOf(prefix) === 0) return decodeURIComponent(part.slice(prefix.length));
      }
    } catch (_) {}
    return '';
  }

  function exclusionReason() {
    try {
      var host = String(window.location.hostname || '').toLowerCase();
      if (host === 'localhost' || host === '127.0.0.1') return 'local';
      if (window.Shopify && window.Shopify.designMode) return 'shopify_design_mode';
      var params = new URLSearchParams(window.location.search || '');
      var mode = safeText(params.get('tbg_analytics_mode') || params.get('analytics_mode'), 24).toLowerCase();
      if (['internal', 'qa', 'canary', 'test'].indexOf(mode) !== -1) return mode;
      if (params.get('tbg_qa') === '1' || params.get('tbg_test') === '1') return 'qa';
      var cookieMode = safeText(readCookie('tbg_analytics_mode'), 24).toLowerCase();
      if (['internal', 'qa', 'canary', 'test'].indexOf(cookieMode) !== -1) return cookieMode;
      if (readCookie(EXCLUSION_COOKIE) === '1') return 'cookie';
    } catch (_) {}
    return '';
  }

  function markExcludedContext() {
    var reason = exclusionReason();
    if (!reason) return false;
    try {
      var secure = window.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = EXCLUSION_COOKIE + '=1; Path=/; Max-Age=' + EXCLUSION_MAX_AGE_SECONDS + '; SameSite=Lax' + secure;
    } catch (_) {}
    window.__TBG_ANALYTICS_EXCLUDED__ = true;
    return true;
  }

  function deviceType() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    if (width < 750) return 'mobile';
    if (width < 990) return 'tablet';
    return 'desktop';
  }

  function scrollDepth() {
    var root = document.documentElement;
    var body = document.body;
    var top = window.scrollY || root.scrollTop || (body && body.scrollTop) || 0;
    var height = Math.max(
      root.scrollHeight,
      root.offsetHeight,
      body ? body.scrollHeight : 0,
      body ? body.offsetHeight : 0
    ) - (window.innerHeight || root.clientHeight || 0);
    if (height <= 0) return 100;
    return Math.max(0, Math.min(100, Math.round((top / height) * 100)));
  }

  function analyticsAllowed() {
    if (markExcludedContext()) return false;
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
        return privacy.analyticsProcessingAllowed() === true;
      }
    } catch (_) {}
    try {
      return Boolean(window.posthog &&
        typeof window.posthog.has_opted_in_capturing === 'function' &&
        window.posthog.has_opted_in_capturing() === true);
    } catch (_) {
      return false;
    }
  }

  function marketingAllowed() {
    if (markExcludedContext()) return false;
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.marketingAllowed === 'function') {
        return privacy.marketingAllowed() === true;
      }
    } catch (_) {}
    return false;
  }

  function commonProperties() {
    return Object.assign({
      schema_version: SCHEMA_VERSION,
      event_schema_version: SCHEMA_VERSION,
      funnel_id: FUNNEL_ID,
      page_id: PAGE_ID,
      page_path: FUNNEL_PATH,
      event_timestamp: new Date().toISOString(),
      page_title: safeText(document.title, 120),
      device_type: deviceType(),
      viewport_width: safeNumber(window.innerWidth),
      viewport_height: safeNumber(window.innerHeight),
      scroll_depth_percent: scrollDepth()
    }, attributionProperties());
  }

  function capture(eventName, properties, options) {
    if (!analyticsAllowed()) return false;
    try {
      if (!window.posthog || typeof window.posthog.capture !== 'function') return false;
      var payload = Object.assign(commonProperties(), properties || {});
      var eventId = safeText(payload.event_id, 180) || randomId('evt');
      payload.event_id = eventId;
      payload.$insert_id = safeText(payload.$insert_id, 180) || eventId;
      window.posthog.capture(
        eventName,
        payload,
        options || undefined
      );
      return true;
    } catch (_) {
      return false;
    }
  }

  function bundleConfig(bundleId) {
    var config = window.NOVAHAIR_SALES_COMMERCE_CONFIG || {};
    var bundles = Array.isArray(config.bundles) ? config.bundles : [];
    return bundles.find(function (bundle) { return bundle.id === bundleId; }) || null;
  }

  function selectedBundleId() {
    var selected = document.querySelector('.bundle-card.sel[data-offer]');
    return selected ? safeText(selected.getAttribute('data-offer'), 32) : '';
  }

  function quantityForShade(shadeId) {
    var node = document.getElementById('mmQty_' + shadeId);
    return node ? Math.max(0, Number.parseInt(node.textContent || '0', 10) || 0) : 0;
  }

  function selectedShades(bundle) {
    var quantities = {};
    var mixedTotal = 0;
    SHADE_IDS.forEach(function (shadeId) {
      var quantity = quantityForShade(shadeId);
      if (quantity > 0) quantities[shadeId] = quantity;
      mixedTotal += quantity;
    });

    var drawer = document.getElementById('mmDrawer');
    var isMixed = Boolean(drawer && drawer.classList.contains('open'));
    if (isMixed && mixedTotal > 0) return quantities;

    var selected = document.querySelector('.shade-option.sel[data-color]');
    var shadeId = selected ? safeText(selected.getAttribute('data-color'), 32) : '';
    if (shadeId) {
      quantities = {};
      quantities[shadeId] = bundle && bundle.quantity ? Number(bundle.quantity) : 1;
    }
    return quantities;
  }

  function shadeSequence(shades) {
    var sequence = [];
    SHADE_IDS.forEach(function (shadeId) {
      var quantity = safeNumber(shades && shades[shadeId]) || 0;
      for (var index = 0; index < quantity; index += 1) sequence.push(shadeId);
    });
    return sequence;
  }

  function selectedBumps() {
    var ids = [];
    document.querySelectorAll('.novafunnel-cart-drawer tr[data-variant-id]').forEach(function (row) {
      var bumpId = BUMP_VARIANTS[Number(row.getAttribute('data-variant-id'))];
      if (bumpId && ids.indexOf(bumpId) === -1) ids.push(bumpId);
    });
    return ids;
  }

  function moneyFromText(value) {
    var match = safeText(value, 80).replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return match ? safeNumber(match[0]) : undefined;
  }

  function selectedState() {
    var bundleId = selectedBundleId();
    var bundle = bundleConfig(bundleId);
    var shades = selectedShades(bundle);
    var shadeIds = Object.keys(shades);
    var sku = '';
    var variantId;

    if (bundle && shadeIds.length) {
      var skuShadeIds = Number(shades.mediumbrown || 0) > 0
        ? SHADE_IDS
        : ['black', 'darkbrown', 'lightbrown', 'purple', 'red'];
      var counts = skuShadeIds.map(function (shadeId) { return Number(shades[shadeId] || 0); });
      sku = 'NOVASALE-' + Number(bundle.quantity) + '-' + counts.join('-');
      variantId = safeNumber(window.NOVASALE_VARIANT_MAP && window.NOVASALE_VARIANT_MAP[sku]);
    }

    return {
      bundle_id: bundleId || undefined,
      selected_bundle: bundleId || undefined,
      bundle_size: bundle ? safeNumber(bundle.quantity) : undefined,
      bottle_quantity: bundle ? safeNumber(bundle.quantity) : undefined,
      bundle_value: bundle ? safeNumber(bundle.priceIls) : undefined,
      displayed_price: bundle ? safeNumber(bundle.priceIls) : undefined,
      cart_value: safeNumber(lastCartSummary.cart_total),
      currency: 'ILS',
      shade_mode: shadeIds.length > 1 ? 'mixed' : 'single',
      selected_shades: shades,
      selected_shade_sequence: shadeSequence(shades),
      bumps: selectedBumps(),
      selection_sku: sku || undefined,
      variant_id: variantId
    };
  }

  function cleanAttributionValue(value) {
    return safeText(value, 240);
  }

  function currentAttribution() {
    var stored = {};
    try { stored = JSON.parse(window.sessionStorage.getItem(ATTRIBUTION_STORAGE_KEY) || '{}') || {}; } catch (_) {}
    var params;
    try { params = new URLSearchParams(window.location.search || ''); } catch (_) { params = new URLSearchParams(); }
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'adset_id', 'ad_id', 'gclid', 'fbclid', 'wbraid', 'gbraid'];
    var changed = false;
    keys.forEach(function (key) {
      var value = cleanAttributionValue(params.get(key));
      if (value && !stored[key]) {
        stored[key] = value;
        changed = true;
      }
    });
    if (!stored.landing_page) {
      stored.landing_page = safeText(window.location.pathname + window.location.search, 500);
      changed = true;
    }
    if (!stored.referrer_host) {
      try { stored.referrer_host = document.referrer ? safeText(new URL(document.referrer).hostname, 160) : ''; } catch (_) {}
      changed = true;
    }
    if (!stored.fbp) {
      stored.fbp = cleanAttributionValue(readCookie('_fbp'));
      changed = Boolean(stored.fbp) || changed;
    }
    if (!stored.fbc) {
      stored.fbc = cleanAttributionValue(readCookie('_fbc'));
      if (!stored.fbc && stored.fbclid) stored.fbc = 'fb.1.' + Date.now() + '.' + stored.fbclid;
      changed = Boolean(stored.fbc) || changed;
    }
    if (changed) {
      try { window.sessionStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(stored)); } catch (_) {}
    }
    return stored;
  }

  function attributionProperties() {
    var attribution = currentAttribution();
    return {
      utm_source: attribution.utm_source || undefined,
      utm_medium: attribution.utm_medium || undefined,
      utm_campaign: attribution.utm_campaign || undefined,
      utm_content: attribution.utm_content || undefined,
      utm_term: attribution.utm_term || undefined,
      adset_id: attribution.adset_id || undefined,
      ad_id: attribution.ad_id || undefined,
      gclid: attribution.gclid || undefined,
      fbclid: attribution.fbclid || undefined,
      wbraid: attribution.wbraid || undefined,
      gbraid: attribution.gbraid || undefined,
      fbp: attribution.fbp || undefined,
      fbc: attribution.fbc || undefined,
      landing_page: attribution.landing_page || undefined,
      referrer_host: attribution.referrer_host || undefined
    };
  }

  function shadeDimension(state) {
    var ids = Object.keys(state && state.selected_shades || {});
    return ids.length === 1 ? ids[0] : (ids.length ? ids.join('|') : undefined);
  }

  function ga4ItemFromState(state) {
    var variantId = safeNumber(state && state.variant_id);
    if (!variantId) return null;
    var shade = shadeDimension(state);
    return {
      item_id: String(variantId),
      item_name: 'NOVAHAIR',
      item_brand: 'TIGERA',
      item_category: 'Hair color',
      item_variant: shade,
      product_id: MAIN_PRODUCT_ID,
      variant_id: String(variantId),
      bundle_id: state.bundle_id,
      shade: shade,
      shade_id: shade,
      price: safeNumber(state.bundle_value),
      quantity: 1
    };
  }

  function ga4ItemFromCartLine(item) {
    item = item || {};
    var variantId = safeNumber(item.variant_id || item.id);
    var productId = safeNumber(item.product_id);
    if (!variantId && !productId) return null;
    var properties = lineProperties(item);
    var bundleId = safeText(properties._BUNDLE_SIZE, 12) ? 'pack' + safeText(properties._BUNDLE_SIZE, 12) : undefined;
    var shade = canonicalShadeFromLineProperties(properties) || undefined;
    return {
      item_id: String(variantId || productId),
      item_name: safeText(item.product_title || item.title, 160) || 'NOVAHAIR',
      item_brand: safeText(item.vendor, 80) || 'TIGERA',
      item_variant: shade,
      product_id: productId ? String(productId) : undefined,
      variant_id: variantId ? String(variantId) : undefined,
      bundle_id: bundleId,
      shade: shade,
      shade_id: shade,
      price: safeNumber(Number(item.final_price || item.price || 0) / 100),
      quantity: safeNumber(item.quantity) || 1
    };
  }

  function canonicalShadeFromLineProperties(properties) {
    properties = properties || {};
    var config = safeText(properties._NOVASALE_CONFIG, 140);
    var configMatch = config.match(/^NOVASALE-\d+-(\d+)-(\d+)-(\d+)-(\d+)-(\d+)-(\d+)$/i);
    var configShadeIds = SHADE_IDS;
    if (!configMatch) {
      configMatch = config.match(/^NOVASALE-\d+-(\d+)-(\d+)-(\d+)-(\d+)-(\d+)$/i);
      configShadeIds = ['black', 'darkbrown', 'lightbrown', 'purple', 'red'];
    }
    if (configMatch) {
      var ids = [];
      configShadeIds.forEach(function (shadeId, index) {
        if ((safeNumber(configMatch[index + 1]) || 0) > 0) ids.push(shadeId);
      });
      if (ids.length) return ids.join('|');
    }

    var label = safeText(properties['בחירת גוונים'], 160).toLowerCase();
    if (!label) return '';
    var inferred = [];
    if (/שחור|black/.test(label)) inferred.push('black');
    if (/חום\s*כהה|dark\s*brown/.test(label)) inferred.push('darkbrown');
    if (/חום\s*בינוני|medium\s*brown/.test(label)) inferred.push('mediumbrown');
    if (/חום\s*בהיר|light\s*brown/.test(label)) inferred.push('lightbrown');
    if (/סגול|חציל|purple|eggplant/.test(label)) inferred.push('purple');
    if (/אדום|בורדו|red|wine/.test(label)) inferred.push('red');
    return inferred.join('|');
  }

  function sendGa4Event(eventName, properties) {
    if (!analyticsAllowed() || typeof window.gtag !== 'function') return false;
    try {
      window.gtag('event', eventName, Object.assign({ send_to: GA4_MEASUREMENT_ID }, properties || {}));
      return true;
    } catch (_) {
      return false;
    }
  }

  function sendMetaViewContent(state, eventId) {
    if (!analyticsAllowed() || !marketingAllowed() || typeof window.fbq !== 'function') return false;
    var variantId = safeNumber(state && state.variant_id);
    if (!variantId) return false;
    try {
      window.fbq('track', 'ViewContent', {
        content_ids: [String(variantId)],
        content_type: 'product',
        content_name: 'NOVAHAIR',
        value: safeNumber(state.bundle_value),
        currency: state.currency || 'ILS'
      }, { eventID: eventId });
      return true;
    } catch (_) {
      return false;
    }
  }

  function captureInitialViewItem() {
    if (!analyticsAllowed()) return;
    var state = selectedState();
    var item = ga4ItemFromState(state);
    if (!item) return;
    if (!initialViewEventId) initialViewEventId = randomId('view-item');
    if (!initialViewItemSent) {
      initialViewItemSent = sendGa4Event('view_item', Object.assign({}, state, attributionProperties(), {
        event_id: initialViewEventId,
        value: safeNumber(state.bundle_value),
        currency: state.currency || 'ILS',
        items: [item]
      }));
    }
    if (!initialMetaViewContentSent) initialMetaViewContentSent = sendMetaViewContent(state, initialViewEventId);
  }

  function enrichGa4AddToCartEntry(entry) {
    if (!entry || entry[0] !== 'event' || entry[1] !== 'add_to_cart') return;
    var action = pendingAction;
    if (!action || action.action_type !== 'main_offer_add') return;
    if (Date.now() - safeNumber(action.action_created_at) > PENDING_ACTION_MAX_AGE_MS) return;
    var params = entry[2];
    if (!params || typeof params !== 'object') return;
    var state = selectedState();
    var shade = shadeDimension(state);
    Object.assign(params, {
      bundle_id: state.bundle_id,
      shade: shade,
      shade_id: shade,
      cta_id: action.cta_id,
      section_id: action.section_id,
      cart_action_id: action.cart_action_id,
      source_cta: action.source_cta
    });
    if (Array.isArray(params.items)) {
      params.items.forEach(function (item) {
        if (!item || typeof item !== 'object') return;
        var variantId = safeNumber(state.variant_id || item.variant_id || item.variantId);
        if (variantId) {
          item.item_id = String(variantId);
          item.variant_id = String(variantId);
        } else if (!item.item_id && item.id) item.item_id = String(item.id);
        item.product_id = MAIN_PRODUCT_ID;
        if (!item.item_name && item.name) item.item_name = item.name;
        if (!item.item_brand && item.brand) item.item_brand = item.brand;
        if (!item.item_category && item.category) item.item_category = item.category;
        if (!item.item_variant && item.variant) item.item_variant = item.variant;
        item.bundle_id = state.bundle_id;
        item.shade = shade;
        item.shade_id = shade;
      });
    }
  }

  function setupGa4AddToCartEnrichment() {
    var layer = window.dataLayer;
    if (!Array.isArray(layer) || layer.__tbgNovaHairEnriched) return;
    var originalPush = layer.push;
    layer.push = function () {
      for (var index = 0; index < arguments.length; index += 1) enrichGa4AddToCartEntry(arguments[index]);
      return originalPush.apply(layer, arguments);
    };
    layer.__tbgNovaHairEnriched = true;
  }

  function writeBridge(extra) {
    if (!analyticsAllowed()) return false;
    var distinctId = '';
    var sessionId = '';
    try {
      distinctId = safeText(window.posthog && window.posthog.get_distinct_id(), 160);
      sessionId = safeText(window.posthog && window.posthog.get_session_id(), 160);
    } catch (_) {}
    if (!distinctId) return false;

    var state = selectedState();
    var currentAction = pendingAction &&
      Date.now() - safeNumber(pendingAction.action_created_at) <= PENDING_ACTION_MAX_AGE_MS
      ? pendingAction
      : {};
    var bridge = Object.assign({
      v: SCHEMA_VERSION,
      funnel_id: FUNNEL_ID,
      page_id: PAGE_ID,
      distinct_id: distinctId,
      session_id: sessionId || undefined,
      bundle_id: state.bundle_id,
      bundle_size: state.bundle_size,
      bundle_value: state.bundle_value,
      currency: state.currency,
      shade_mode: state.shade_mode,
      selected_shades: state.selected_shades,
      selection_sku: state.selection_sku,
      variant_id: state.variant_id,
      recent_actions: recentActions,
      captured_at: new Date().toISOString(),
      expires_at: Date.now() + (BRIDGE_MAX_AGE_SECONDS * 1000)
    }, attributionProperties(), currentAction, extra || {});

    Object.keys(bridge).forEach(function (key) {
      if (bridge[key] === undefined || bridge[key] === '') delete bridge[key];
    });

    try {
      var value = encodeURIComponent(JSON.stringify(bridge));
      var fingerprint = value.replace(/%22captured_at%22%3A%22[^%]+%22%2C?/, '');
      if (fingerprint === lastBridgeFingerprint && !extra) return true;
      lastBridgeFingerprint = fingerprint;
      var secure = window.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = BRIDGE_COOKIE + '=' + value + '; Path=/; Max-Age=' +
        BRIDGE_MAX_AGE_SECONDS + '; SameSite=Lax' + secure;
      return true;
    } catch (_) {
      return false;
    }
  }

  function rememberAction(actionType, details) {
    var state = selectedState();
    pendingAction = Object.assign({
      cart_action_id: randomId('cart'),
      action_type: actionType,
      action_created_at: Date.now(),
      pending_variant_id: state.variant_id
    }, details || {});
    recentActions.push({
      cart_action_id: pendingAction.cart_action_id,
      action_type: pendingAction.action_type,
      action_created_at: pendingAction.action_created_at,
      pending_variant_id: pendingAction.pending_variant_id,
      item_role: pendingAction.item_role,
      bump_id: pendingAction.bump_id,
      cta_id: pendingAction.cta_id,
      section_id: pendingAction.section_id,
      source_cta: pendingAction.source_cta
    });
    recentActions = recentActions.slice(-5);
    writeBridge(pendingAction);
    return pendingAction.cart_action_id;
  }

  function sectionForElement(element) {
    if (!element || typeof element.closest !== 'function') return {};
    for (var index = 0; index < SECTION_MAP.length; index += 1) {
      var config = SECTION_MAP[index];
      if (element.closest(config.selector)) {
        return { section_id: config.id, section_name: config.name, section_index: index + 1 };
      }
    }
    if (element.closest('cart-drawer')) {
      return { section_id: 'cart_drawer', section_name: 'Cart drawer', section_index: SECTION_MAP.length + 1 };
    }
    return {};
  }

  function destinationFor(element) {
    var href = element && element.closest && element.closest('a[href]');
    var raw = href ? href.getAttribute('href') : '';
    if (!raw && element && element.matches && element.matches('[data-return-to-buybox]')) raw = '#buy';
    if (!raw) return undefined;
    try {
      var parsed = new URL(raw, window.location.origin);
      return parsed.pathname + (parsed.hash || '');
    } catch (_) {
      return safeText(raw.split('?')[0], 160) || undefined;
    }
  }

  function ctaIdFor(element) {
    if (!element) return '';
    if (element.id === 'mainCheckout') return 'main_checkout';
    if (element.id === 'stickyCtaBtn') return 'sticky_checkout';
    if (element.id === 'CartDrawer-Checkout') return 'cart_drawer_checkout';
    if (element.matches('[data-return-to-buybox]')) {
      var location = element.closest('[data-cta-location]');
      if (location) return 'return_to_buybox_' + safeText(location.getAttribute('data-cta-location'), 48);
      if (element.matches('.nh-reentry-mobile')) return 'offer_reentry_mobile';
      return 'return_to_buybox';
    }
    if (element.matches('.nh-reentry-card[data-offer], .nh-reentry-card')) {
      var offer = element.getAttribute('data-offer') || selectedBundleId();
      return 'offer_reentry_' + safeText(offer || 'bundle', 32);
    }
    if (element.matches('.ugc-modal__cta')) return 'review_modal_cta';
    if (element.matches('#csMobilePanel [data-vid]')) return 'cart_bump_' + safeText(element.getAttribute('data-vid'), 32);
    if (element.matches('.nh-exit-popup__submit')) return 'exit_offer_submit';
    if (element.matches('[data-popup-continue]')) return 'exit_offer_continue';
    if (element.matches('[data-popup-close]')) return 'exit_offer_close';
    if (element.closest('footer.footer')) {
      var destination = destinationFor(element) || 'unknown';
      return 'footer_' + destination.replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_|_$/g, '').slice(0, 64);
    }
    return safeText(element.id || element.getAttribute('data-cta-id'), 72);
  }

  function captureCta(element, extra, options) {
    var ctaId = ctaIdFor(element);
    if (!ctaId) return false;
    var state = selectedState();
    var section = sectionForElement(element);
    return capture('cta_clicked', Object.assign(
      {},
      section,
      state,
      {
        cta_id: ctaId,
        cta_text: safeText(element.getAttribute('aria-label') || element.textContent, 120),
        cta_location: section.section_id || 'page',
        source_section: section.section_id || 'page',
        destination: destinationFor(element),
        cart_value: safeNumber(lastCartSummary.cart_total) || state.bundle_value
      },
      extra || {}
    ), options);
  }

  function isSectionVisible(entry) {
    if (!entry || !entry.element || !entry.element.isConnected) return false;
    var rect = entry.element.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    var visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
    var required = Math.min(rect.height * 0.5, viewportHeight * 0.5);
    return rect.width > 0 && rect.height > 0 && visibleHeight >= required;
  }

  function nowMs() {
    return Date.now();
  }

  function sectionState(entry) {
    var id = entry && entry.config && entry.config.id;
    if (!id) return null;
    if (!sectionStates.has(id)) {
      sectionStates.set(id, {
        active: false,
        activated: false,
        enteredAt: 0,
        accumulatedMs: 0,
        recordedVisits: 0,
        lastExitReason: ''
      });
    }
    return sectionStates.get(id);
  }

  function sectionProperties(entry, state, extra) {
    var deepest = deepestSection || entry;
    return Object.assign({
      section_id: entry.config.id,
      section_name: entry.config.name,
      section_index: entry.index + 1,
      visibility_threshold: 0.5,
      section_visible_duration_ms: Math.max(0, Math.round(state.accumulatedMs)),
      section_returned: state.recordedVisits > 1,
      section_return_count: Math.max(0, state.recordedVisits - 1),
      deepest_section: deepest && deepest.config ? deepest.config.id : undefined,
      deepest_section_name: deepest && deepest.config ? deepest.config.name : undefined,
      deepest_section_index: deepest ? deepest.index + 1 : undefined
    }, extra || {});
  }

  function markDeepest(entry) {
    if (!deepestSection || entry.index > deepestSection.index) deepestSection = entry;
  }

  function activateSection(entry) {
    var state = sectionState(entry);
    if (!state || !state.active || state.activated || !isSectionVisible(entry)) return;
    state.activated = true;
    state.recordedVisits += 1;
    markDeepest(entry);

    var elapsed = Math.max(0, nowMs() - state.enteredAt);

    capture('section_enter', sectionProperties(entry, state, {
      section_visible_duration_ms: Math.round(state.accumulatedMs + elapsed),
      section_entered_at: new Date(state.enteredAt).toISOString(),
      section_visit_number: state.recordedVisits
    }));

    // Keep the legacy event for existing PostHog insights while reporting a real dwell time.
    if (!sectionSeen[entry.config.id] && capture('section_viewed', sectionProperties(entry, state, {
      section_visible_duration_ms: undefined,
      visible_duration_ms: undefined,
      section_visit_number: state.recordedVisits
    }))) sectionSeen[entry.config.id] = true;
  }

  function armSection(entry) {
    var state = sectionState(entry);
    if (!state || state.active || !analyticsAllowed() || !isSectionVisible(entry)) return;
    state.active = true;
    state.activated = false;
    state.enteredAt = nowMs();

    var timer = window.setTimeout(function () {
      sectionTimers.delete(entry.config.id);
      activateSection(entry);
    }, 500);
    sectionTimers.set(entry.config.id, timer);
  }

  function disarmSection(entry, reason) {
    var state = sectionState(entry);
    if (!state || !state.active) return;
    if (sectionTimers.has(entry.config.id)) {
      window.clearTimeout(sectionTimers.get(entry.config.id));
      sectionTimers.delete(entry.config.id);
    }

    var endedAt = nowMs();
    var visitDuration = Math.max(0, endedAt - state.enteredAt);
    if (state.activated) {
      state.accumulatedMs += visitDuration;
      state.lastExitReason = reason || 'not_visible';
      var exitPayload = sectionProperties(entry, state, {
        section_visit_duration_ms: Math.round(visitDuration),
        exit_section: entry.config.id,
        exit_reason: state.lastExitReason,
        section_exited_at: new Date().toISOString()
      });
      var instantExit = state.lastExitReason === 'page_exit' || state.lastExitReason === 'tab_hidden';
      capture('section_exit', exitPayload, instantExit ? {
        transport: 'sendBeacon',
        send_instantly: true
      } : undefined);
    }
    state.active = false;
    state.activated = false;
    state.enteredAt = 0;
  }

  function checkVisibleSections(reason) {
    sectionEntries.forEach(function (entry) {
      if (isSectionVisible(entry)) armSection(entry);
      else disarmSection(entry, reason || 'not_visible');
    });
  }

  function flushVisibleSections(reason) {
    sectionEntries.forEach(function (entry) { disarmSection(entry, reason || 'page_exit'); });
  }

  function setupSectionTracking() {
    sectionEntries = SECTION_MAP.map(function (config, index) {
      var element = document.querySelector(config.selector);
      return element ? { config: config, index: index, element: element } : null;
    }).filter(Boolean);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (observed) {
          var entry = sectionEntries.find(function (candidate) { return candidate.element === observed.target; });
          if (!entry) return;
          if (isSectionVisible(entry)) armSection(entry);
          else disarmSection(entry, 'not_visible');
        });
      }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
      sectionEntries.forEach(function (entry) { observer.observe(entry.element); });
    }
    window.addEventListener('scroll', function () {
      if (sectionScrollFrame) return;
      sectionScrollFrame = window.requestAnimationFrame(function () {
        sectionScrollFrame = 0;
        checkVisibleSections('scroll');
      });
    }, { passive: true });
    window.addEventListener('resize', function () { checkVisibleSections('resize'); }, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) flushVisibleSections('tab_hidden');
      else checkVisibleSections('tab_visible');
    });
    window.addEventListener('pagehide', function () { flushVisibleSections('page_exit'); });
    checkVisibleSections();
  }

  function readCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return window.fetch(root + 'cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart read failed');
      return response.json();
    });
  }

  function cartSummary(cart) {
    var itemCount = safeNumber(cart && cart.item_count);
    var cartValue = cart ? safeNumber(Number(cart.total_price || 0) / 100) : undefined;
    return {
      cart_token: safeText(cart && cart.token, 120) || undefined,
      cart_item_count: itemCount,
      item_count: itemCount,
      cart_total: cartValue,
      cart_value: cartValue,
      currency: safeText(cart && cart.currency, 8) || 'ILS'
    };
  }

  function currentCartToken() {
    var token = safeText(lastCartSummary.cart_token, 120);
    if (token) return token;
    var cookieToken = safeText(readCookie('cart'), 240);
    if (!cookieToken) return undefined;
    return safeText(cookieToken.split('?')[0], 120) || undefined;
  }

  function cartLine(cart, predicate) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.find(predicate) || null;
  }

  function pollCart(predicate, attempts) {
    var delays = attempts || [120, 360, 800, 1400, 2400];
    return new Promise(function (resolve) {
      var index = 0;
      function next() {
        window.setTimeout(function () {
          readCart().then(function (cart) {
            if (predicate(cart)) resolve(cart);
            else if (index < delays.length) next();
            else resolve(null);
          }).catch(function () {
            if (index < delays.length) next();
            else resolve(null);
          });
        }, delays[index++] || 0);
      }
      next();
    });
  }

  function lineProperties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function isBumpLine(item) {
    var properties = lineProperties(item);
    return Boolean(BUMP_VARIANTS[Number(item && item.variant_id)] ||
      properties._NOVAFUNNEL_ROLE === 'BUMP' ||
      properties._NOVAFUNNEL_ROLE === 'CROSS_SELL');
  }

  function captureDrawerCart(cart, sequence, triggerAction) {
    var drawer = document.querySelector('cart-drawer');
    if (sequence !== drawerOpenSequence || !drawer || !drawer.classList.contains('active')) return;
    lastCartSummary = cartSummary(cart);
    var action = triggerAction || {};
    var eventId = randomId('view-cart');
    var state = selectedState();
    capture('cart_opened', Object.assign({}, lastCartSummary, state, {
      event_id: eventId,
      cart_action_id: action.cart_action_id,
      trigger: action.action_type || 'cart_drawer'
    }));
    var items = (cart && Array.isArray(cart.items) ? cart.items : []).map(ga4ItemFromCartLine).filter(Boolean);
    if (items.length) {
      sendGa4Event('view_cart', Object.assign({}, attributionProperties(), {
        event_id: eventId,
        value: lastCartSummary.cart_value,
        currency: lastCartSummary.currency,
        item_count: lastCartSummary.item_count,
        bundle_id: state.bundle_id,
        cart_action_id: action.cart_action_id,
        source_cta: action.source_cta,
        items: items
      }));
    }
    writeBridge(Object.assign({}, lastCartSummary, { view_cart_event_id: eventId }));
  }

  function captureDrawerWhenStable() {
    var sequence = ++drawerOpenSequence;
    var action = pendingAction ? Object.assign({}, pendingAction) : {};
    var expectedVariantId = safeNumber(action.pending_variant_id);
    var cartPromise;
    if (action.action_type === 'main_offer_add' && expectedVariantId) {
      cartPromise = pollCart(function (cart) {
        return Boolean(cartLine(cart, function (item) { return Number(item.variant_id) === expectedVariantId; }));
      }).then(function (cart) { return cart || readCart(); });
    } else {
      cartPromise = readCart();
    }
    cartPromise.then(function (cart) {
      captureDrawerCart(cart, sequence, action);
    }).catch(function () {});
  }

  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    drawerWasOpen = drawer.classList.contains('active');
    new MutationObserver(function () {
      var isOpen = drawer.classList.contains('active');
      if (isOpen && !drawerWasOpen) {
        captureDrawerWhenStable();
      }
      drawerWasOpen = isOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function captureBundleSelection(element) {
    var bundleId = safeText(element.getAttribute('data-offer'), 32);
    var bundle = bundleConfig(bundleId);
    var previousBundleId = selectedBundleId();
    var compareAtPrice = moneyFromText(element.querySelector('.bundle-card__old') && element.querySelector('.bundle-card__old').textContent);
    window.setTimeout(function () {
      capture('bundle_selected', Object.assign({}, selectedState(), {
        bundle_id: bundleId,
        bundle_name: bundle && safeText(bundle.displayTitle, 120),
        bundle_size: bundle && safeNumber(bundle.quantity),
        bottle_quantity: bundle && safeNumber(bundle.quantity),
        bundle_value: bundle && safeNumber(bundle.priceIls),
        displayed_price: bundle && safeNumber(bundle.priceIls),
        compare_at_price: compareAtPrice,
        previous_bundle_id: previousBundleId || undefined,
        selection_location: sectionForElement(element).section_id || 'buy_box'
      }));
      writeBridge();
    }, 0);
  }

  function captureShadeSelection(element, interactionType) {
    window.setTimeout(function () {
      var state = selectedState();
      var shadeId = safeText(element.getAttribute('data-color'), 32);
      var selectedCount = Object.keys(state.selected_shades || {}).reduce(function (sum, key) {
        return sum + (safeNumber(state.selected_shades[key]) || 0);
      }, 0);
      capture('shade_selected', Object.assign({}, state, {
        shade: shadeId || undefined,
        shade_id: shadeId || undefined,
        shade_position: shadeId ? SHADE_IDS.indexOf(shadeId) + 1 : undefined,
        required_shade_count: state.bundle_size,
        selection_complete: Boolean(state.bundle_size && selectedCount === state.bundle_size),
        interaction_type: interactionType || 'shade_option',
        selection_location: sectionForElement(element).section_id || 'buy_box'
      }));
      writeBridge();
    }, 0);
  }

  function startMainAdd(element) {
    var state = selectedState();
    var ctaId = ctaIdFor(element);
    var section = sectionForElement(element);
    var actionId = rememberAction('main_offer_add', {
      pending_variant_id: state.variant_id,
      item_role: 'main_offer',
      cta_id: ctaId,
      source_cta: ctaId,
      section_id: section.section_id || 'buy_box'
    });
    captureCta(element, { cart_action_id: actionId, cta_role: 'add_to_cart' });
    capture('add_to_cart_attempted', Object.assign({}, state, {
      cart_action_id: actionId,
      item_role: 'main_offer',
      cta_id: ctaId,
      source_cta: ctaId,
      expected_quantity: state.bundle_size,
      expected_cart_value: state.bundle_value
    }));
  }

  function startBumpAdd(element, variantId) {
    var actionId = rememberAction('bump_add', {
      pending_variant_id: variantId,
      item_role: 'bump',
      bump_id: BUMP_VARIANTS[variantId] || ('variant_' + variantId)
    });
    captureCta(element, {
      cart_action_id: actionId,
      cta_role: 'bump_add',
      item_role: 'bump',
      variant_id: variantId,
      bump_id: BUMP_VARIANTS[variantId] || ('variant_' + variantId)
    });
    writeBridge();
  }

  function handleCartRemove(element) {
    var row = element.closest('tr[data-line-key]');
    if (!row) return;
    var lineKey = safeText(row.getAttribute('data-line-key'), 180);
    var variantId = safeNumber(row.getAttribute('data-variant-id') || element.getAttribute('data-variant-id'));
    var previousQuantity = safeNumber(row.querySelector('.quantity__input') && row.querySelector('.quantity__input').value) || 1;
    var actionId = rememberAction('cart_remove', {
      pending_variant_id: variantId,
      line_key: lineKey,
      item_role: row.getAttribute('data-novafunnel-main-offer') === 'true' ? 'main_offer' : 'cart_item'
    });
    pollCart(function (cart) {
      return !cartLine(cart, function (item) { return safeText(item.key, 180) === lineKey; });
    }).then(function (cart) {
      if (!cart) return;
      lastCartSummary = cartSummary(cart);
      capture('cart_item_removed', Object.assign({}, lastCartSummary, {
        cart_action_id: actionId,
        line_key: lineKey,
        variant_id: variantId,
        previous_quantity: previousQuantity,
        quantity_removed: previousQuantity,
        cart_value_after: lastCartSummary.cart_value,
        item_role: row.getAttribute('data-novafunnel-main-offer') === 'true' ? 'main_offer' : 'cart_item'
      }));
      writeBridge(lastCartSummary);
    });
  }

  function handleQuantityChange(element, desiredQuantity) {
    var row = element.closest('tr[data-line-key]');
    if (!row) return;
    var lineKey = safeText(row.getAttribute('data-line-key'), 180);
    var variantId = safeNumber(row.getAttribute('data-variant-id'));
    var input = row.querySelector('.quantity__input');
    var previousQuantity = safeNumber(input && input.value) || 0;
    var nextQuantity = Math.max(0, safeNumber(desiredQuantity) || 0);
    if (previousQuantity === nextQuantity) return;
    var actionId = rememberAction('cart_quantity_change', {
      pending_variant_id: variantId,
      line_key: lineKey,
      desired_quantity: nextQuantity
    });
    pollCart(function (cart) {
      var item = cartLine(cart, function (candidate) { return safeText(candidate.key, 180) === lineKey; });
      return nextQuantity === 0 ? !item : Boolean(item && Number(item.quantity) === nextQuantity);
    }).then(function (cart) {
      if (!cart) return;
      lastCartSummary = cartSummary(cart);
      capture(nextQuantity === 0 ? 'cart_item_removed' : 'cart_quantity_changed', Object.assign({}, lastCartSummary, {
        cart_action_id: actionId,
        line_key: lineKey,
        variant_id: variantId,
        previous_quantity: previousQuantity,
        old_quantity: previousQuantity,
        quantity: nextQuantity,
        new_quantity: nextQuantity,
        quantity_removed: nextQuantity === 0 ? previousQuantity : undefined,
        cart_value_after: nextQuantity === 0 ? lastCartSummary.cart_value : undefined,
        action: nextQuantity > previousQuantity ? 'increase' : 'decrease'
      }));
      writeBridge(lastCartSummary);
    });
  }

  function handleClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var mainAdd = target.closest('#mainCheckout, #stickyCtaBtn');
    if (mainAdd) {
      startMainAdd(mainAdd);
      return;
    }

    var checkout = target.closest('#CartDrawer-Checkout');
    if (checkout) {
      var actionId = rememberAction('checkout_click', { item_role: 'checkout' });
      var checkoutState = selectedState();
      var destinationUrl = window.location.origin + '/checkout';
      captureCta(checkout, { cart_action_id: actionId, cta_role: 'checkout' }, {
        transport: 'sendBeacon',
        send_instantly: true
      });
      capture('checkout_clicked', Object.assign({}, lastCartSummary, checkoutState, {
        cart_action_id: actionId,
        cta_id: 'cart_drawer_checkout',
        source: 'cart_drawer_checkout',
        source_cta: 'cart_drawer_checkout',
        cart_token: currentCartToken(),
        destination_url: destinationUrl,
        value: safeNumber(lastCartSummary.cart_total) || safeNumber(checkoutState.bundle_value),
        currency: lastCartSummary.currency || checkoutState.currency || 'ILS',
        item_count: safeNumber(lastCartSummary.item_count) || safeNumber(checkoutState.bundle_size),
        bundle_id: checkoutState.bundle_id
      }), { transport: 'sendBeacon', send_instantly: true });
      writeBridge(Object.assign({}, lastCartSummary, {
        cart_token: currentCartToken(),
        checkout_clicked_at: Date.now(),
        destination_url: destinationUrl
      }));
      return;
    }

    var bundle = target.closest('.bundle-card[data-offer]');
    if (bundle) {
      captureBundleSelection(bundle);
      return;
    }

    var reentry = target.closest('.nh-reentry-card');
    if (reentry) {
      var offerMatch = safeText(reentry.getAttribute('onclick'), 120).match(/pack[246]/);
      if (offerMatch && !reentry.getAttribute('data-offer')) reentry.setAttribute('data-offer', offerMatch[0]);
      captureCta(reentry, { cta_role: 'offer_reentry' });
      captureBundleSelection(reentry);
      return;
    }

    var shade = target.closest('.shade-option[data-color]');
    if (shade) {
      captureShadeSelection(shade, 'shade_option');
      return;
    }

    var mixToggle = target.closest('#mixShadesBtn');
    if (mixToggle) {
      captureShadeSelection(mixToggle, 'mix_mode_toggle');
      return;
    }

    var mixQuantity = target.closest('.mm-btn');
    if (mixQuantity) {
      captureShadeSelection(mixQuantity, 'mix_quantity');
      return;
    }

    var thumb = target.closest('.thumb');
    if (thumb) {
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumb'));
      capture('gallery_interacted', Object.assign({}, sectionForElement(thumb), {
        interaction_type: 'thumbnail',
        media_index: thumbs.indexOf(thumb) + 1,
        image_index: thumbs.indexOf(thumb) + 1,
        image_id: safeText(thumb.getAttribute('data-media-id') || thumb.getAttribute('src'), 160) || undefined,
        media_alt: safeText(thumb.getAttribute('alt'), 120)
      }));
      return;
    }

    var galleryArrow = target.closest('.nh-gallery-arrow');
    if (galleryArrow) {
      capture('gallery_interacted', Object.assign({}, sectionForElement(galleryArrow), {
        interaction_type: galleryArrow.classList.contains('nh-gallery-arrow--next') ? 'next' : 'previous'
      }));
      return;
    }

    var faq = target.closest('.faq-item__trigger');
    if (faq) {
      if (faq.getAttribute('aria-expanded') !== 'true') {
        var faqs = Array.prototype.slice.call(document.querySelectorAll('.faq-item__trigger'));
        capture('faq_opened', Object.assign({}, sectionForElement(faq), {
          faq_id: safeText(faq.getAttribute('aria-controls'), 72) || ('faq_' + (faqs.indexOf(faq) + 1)),
          faq_index: faqs.indexOf(faq) + 1,
          question: safeText(faq.textContent, 180),
          faq_question: safeText(faq.textContent, 180)
        }));
      }
      return;
    }

    var reviewControl = target.closest('.ugc-dot, .nh-ugc-arrow, .ugc-review-card, .ugc-modal__close, .ugc-modal__prev, .ugc-modal__next');
    if (reviewControl) {
      var reviewCards = Array.prototype.slice.call(document.querySelectorAll('.ugc-review-card'));
      var interaction = 'carousel';
      if (reviewControl.matches('.ugc-review-card')) interaction = 'review_opened';
      else if (reviewControl.matches('.ugc-modal__close')) interaction = 'modal_closed';
      else if (reviewControl.matches('.ugc-modal__prev')) interaction = 'modal_previous';
      else if (reviewControl.matches('.ugc-modal__next')) interaction = 'modal_next';
      capture('reviews_interacted', Object.assign({}, sectionForElement(reviewControl), {
        interaction_type: interaction,
        review_index: reviewControl.matches('.ugc-review-card') ? reviewCards.indexOf(reviewControl) + 1 : undefined,
        review_id: safeText(reviewControl.getAttribute('data-review-id'), 80) ||
          (reviewControl.matches('.ugc-review-card') ? 'review_' + (reviewCards.indexOf(reviewControl) + 1) : undefined)
      }));
      return;
    }

    var bumpButton = target.closest('#csMobilePanel [data-vid]');
    if (bumpButton) {
      startBumpAdd(bumpButton, Number(bumpButton.getAttribute('data-vid')));
      return;
    }

    var removeButton = target.closest('.novafunnel-cart-drawer cart-remove-button button');
    if (removeButton) {
      handleCartRemove(removeButton);
      return;
    }

    var quantityButton = target.closest('.novafunnel-cart-drawer quantity-input .quantity__button');
    if (quantityButton) {
      var quantityInput = quantityButton.closest('quantity-input') && quantityButton.closest('quantity-input').querySelector('.quantity__input');
      var current = safeNumber(quantityInput && quantityInput.value) || 0;
      handleQuantityChange(quantityButton, quantityButton.name === 'plus' ? current + 1 : current - 1);
      return;
    }

    var popupClose = target.closest('[data-popup-close]');
    if (popupClose) {
      captureCta(popupClose, { cta_role: 'exit_offer_close' });
      capture('exit_offer_dismissed', { popup_id: 'novahair-sales-staging' });
      return;
    }

    var explicitCta = target.closest('[data-return-to-buybox], .nh-reentry-mobile, .ugc-modal__cta, .nh-exit-popup__submit, [data-popup-continue], footer.footer a[href]');
    if (explicitCta) {
      captureCta(explicitCta, { cta_role: 'navigation' });
      if (explicitCta.matches('.nh-exit-popup__submit')) {
        capture('exit_offer_submitted', { popup_id: 'novahair-sales-staging' });
      }
    }
  }

  function handleChange(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var bumpCheckbox = target.closest('input[onchange*="toggleCartBump"]');
    if (bumpCheckbox) {
      var handler = safeText(bumpCheckbox.getAttribute('onchange'), 200);
      var variantMatch = handler.match(/toggleCartBump\((\d+)/);
      var variantId = variantMatch ? Number(variantMatch[1]) : 0;
      if (bumpCheckbox.checked) startBumpAdd(bumpCheckbox, variantId);
      else rememberAction('bump_remove', {
        pending_variant_id: variantId,
        item_role: 'bump',
        bump_id: BUMP_VARIANTS[variantId] || ('variant_' + variantId)
      });
      return;
    }

    var quantityInput = target.closest('.novafunnel-cart-drawer .quantity__input');
    if (quantityInput) handleQuantityChange(quantityInput, quantityInput.value);
  }

  function setupGallerySwipe() {
    var gallery = document.getElementById('galMain');
    if (!gallery) return;
    var startX = null;
    gallery.addEventListener('touchstart', function (event) {
      startX = event.touches && event.touches[0] ? event.touches[0].clientX : null;
    }, { passive: true });
    gallery.addEventListener('touchend', function (event) {
      if (startX === null) return;
      var endX = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : startX;
      var delta = endX - startX;
      startX = null;
      if (Math.abs(delta) < 40) return;
      capture('gallery_interacted', Object.assign({}, sectionForElement(gallery), {
        interaction_type: 'swipe',
        direction: delta < 0 ? 'left' : 'right'
      }));
    }, { passive: true });
  }

  function setupPopupObservation() {
    var popup = document.querySelector('[data-nh-exit-popup]');
    if (!popup || !('MutationObserver' in window)) return;
    var wasVisible = !popup.hidden;
    new MutationObserver(function () {
      var isVisible = !popup.hidden;
      if (isVisible && !wasVisible) capture('exit_offer_viewed', { popup_id: 'novahair-sales-staging' });
      wasVisible = isVisible;
    }).observe(popup, { attributes: true, attributeFilter: ['hidden', 'class'] });
  }

  function handleCommerceFailure(event) {
    var detail = event && event.detail ? event.detail : {};
    var action = pendingAction || {};
    var isMain = detail.operation === 'main_offer_add' || action.action_type === 'main_offer_add';
    capture(isMain ? 'add_to_cart_failed' : 'cart_action_failed', Object.assign({}, selectedState(), {
      cart_action_id: action.cart_action_id,
      action_type: detail.operation || action.action_type,
      item_role: detail.itemRole || action.item_role,
      variant_id: safeNumber(detail.variantId || action.pending_variant_id),
      error_type: 'shopify_cart_operation',
      error_code: safeText(detail.errorCode || 'unknown', 80),
      sanitized_error_code: safeText(detail.errorCode || 'unknown', 80),
      source_cta: isMain ? 'main_checkout' : undefined
    }));
    writeBridge({
      cart_action_id: action.cart_action_id,
      action_status: 'failed',
      cart_action_failed_at: Date.now()
    });
    if (pendingAction && pendingAction.cart_action_id === action.cart_action_id) pendingAction = null;
  }

  function actionWasSent(actionId) {
    if (!actionId) return true;
    if (sentActionIds[actionId]) return true;
    try { return window.sessionStorage.getItem('tbg_atc_sent_' + actionId) === '1'; } catch (_) { return false; }
  }

  function markActionSent(actionId) {
    if (!actionId) return;
    sentActionIds[actionId] = true;
    try { window.sessionStorage.setItem('tbg_atc_sent_' + actionId, '1'); } catch (_) {}
  }

  function handleCommerceSuccess(event) {
    var detail = event && event.detail ? event.detail : {};
    var action = pendingAction ? Object.assign({}, pendingAction) : {};
    var isMain = action.action_type === 'main_offer_add' || detail.operation === 'main_offer_add';
    readCart().then(function (cart) {
      lastCartSummary = cartSummary(cart);
      if (isMain && detail.alreadyPresent !== true && action.cart_action_id && !actionWasSent(action.cart_action_id)) {
        var variantId = safeNumber(detail.variantId || action.pending_variant_id);
        var item = cartLine(cart, function (candidate) { return Number(candidate.variant_id) === variantId; });
        var eventId = 'atc:' + action.cart_action_id;
        // The Shopify Customer Pixel owns authoritative PostHog commerce events.
        // The storefront only records the completed action in the identity bridge,
        // preventing a second add_to_cart_succeeded for the same customer action.
        markActionSent(action.cart_action_id);
        writeBridge(Object.assign({}, lastCartSummary, {
          cart_action_id: action.cart_action_id,
          cart_action_event_id: eventId,
          cart_action_variant_id: item && safeNumber(item.variant_id),
          cart_action_completed_at: Date.now()
        }));
      } else {
        writeBridge(lastCartSummary);
      }
      if (pendingAction && pendingAction.cart_action_id === action.cart_action_id) pendingAction = null;
    }).catch(function () {});
  }

  function init() {
    markExcludedContext();
    currentAttribution();
    setupGa4AddToCartEnrichment();
    setupSectionTracking();
    observeDrawer();
    setupGallerySwipe();
    setupPopupObservation();
    readCart().then(function (cart) {
      lastCartSummary = cartSummary(cart);
      writeBridge(lastCartSummary);
    }).catch(function () {});
    window.addEventListener('click', handleClick, true);
    window.addEventListener('change', handleChange, true);
    document.addEventListener('sales-page-commerce:failed', handleCommerceFailure);
    document.addEventListener('sales-page-commerce:added', handleCommerceSuccess);
    document.addEventListener('sales-page-commerce:unique-added', handleCommerceSuccess);
    document.addEventListener('visitorConsentCollected', function () {
      writeBridge();
      checkVisibleSections();
      captureInitialViewItem();
    });

    var initialViewAttempts = 0;
    var initialViewTimer = window.setInterval(function () {
      initialViewAttempts += 1;
      setupGa4AddToCartEnrichment();
      captureInitialViewItem();
      if ((initialViewItemSent && initialMetaViewContentSent) || initialViewAttempts >= 20) {
        window.clearInterval(initialViewTimer);
      }
    }, 500);

    var bridgeAttempts = 0;
    var bridgeTimer = window.setInterval(function () {
      bridgeAttempts += 1;
      if (writeBridge() || bridgeAttempts >= 20) window.clearInterval(bridgeTimer);
      if (analyticsAllowed()) checkVisibleSections();
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})(window, document);
